import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
    const navigate = useNavigate();
    return (
        <div
            className="
                flex
                h-screen
                w-screen
                items-center
                justify-center
                overflow-hidden
                bg-gradient-to-r
                from-green-light-1
                to-green-light-2
                "
        >
            <div className="rounded-md bg-white px-40 py-20 shadow-xl">
                <div className="flex flex-col items-center">
                    <h1 className="text-9xl font-bold text-green">404</h1>

                    <h6 className="mb-2 text-center text-2xl font-bold text-gray-800 md:text-3xl">
                        <span className="text-red-500">Oops!</span> Page not found
                    </h6>

                    <p className="mb-8 text-center text-gray-500 md:text-lg">
                        The page you’re looking for doesn’t exist.
                    </p>

                    <Button onClick={() => navigate("/")}>Go Home</Button>
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;
